import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VSnackbar,
    _vm._b(
      {
        staticClass: "core-snackbar",
        scopedSlots: _vm._u(
          [
            _setup.action
              ? {
                  key: "action",
                  fn: function ({ attrs }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          { on: { click: _setup.actionClick } },
                          "v-btn",
                          { ...attrs, ..._setup.action },
                          false
                        ),
                        [
                          _vm._v(
                            "\n      " +
                              _vm._s(_setup.action.btnText) +
                              "\n    "
                          ),
                        ]
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _setup.isVisible,
          callback: function ($$v) {
            _setup.isVisible = $$v
          },
          expression: "isVisible",
        },
      },
      "v-snackbar",
      _setup.snackbar,
      false
    ),
    [_vm._v("\n  " + _vm._s(_setup.text) + "\n\n  ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }